module.exports = __webpack_public_path__ + "static/NFC_outdoorschool_Logo_Greyscale_RGB-5a943c2010f1c4b3f5598d70853ae3af.png";